// Caché en memoria para lo que se pinta al entrar en una página.
//
// Cada navegación volvía a pedir todo desde cero: ir a Explorar y volver al
// Feed son dos cargas completas con su spinner, aunque los datos tengan diez
// segundos. Aquí la página se pinta al instante con lo último que se vio y
// la petición sigue haciéndose por detrás para refrescar (stale-while-
// revalidate). Si los datos han cambiado, se actualizan solos; si no, el
// usuario no ve ni un parpadeo.
//
// En memoria y no en localStorage a propósito: son datos de otros usuarios
// sujetos a permisos (RLS), y no deben sobrevivir a un cierre de sesión ni
// quedarse escritos en el disco de un móvil compartido. Al recargar la
// pestaña se pierde, que es justo lo que se quiere.

const TTL_POR_DEFECTO = 60 * 1000; // 1 minuto
const store = new Map();

/**
 * Devuelve lo cacheado para esa clave, o null si no hay o ya caducó.
 */
export function getCached(key, ttl = TTL_POR_DEFECTO) {
  const hit = store.get(key);
  if(!hit) return null;
  // >= y no >: con ttl 0 ("no me sirve nada cacheado") y una lectura en el
  // mismo milisegundo, 0 > 0 es falso y devolvía el valor igualmente.
  if(Date.now() - hit.t >= ttl) { store.delete(key); return null; }
  return hit.v;
}

export function setCached(key, value) {
  store.set(key, { v: value, t: Date.now() });
}

/**
 * Invalida claves. Sin argumentos vacía todo (al cerrar sesión: lo cacheado
 * se leyó con los permisos del usuario anterior).
 * Con un prefijo, sólo lo que empiece por él — p.ej. tras publicar un post,
 * invalidateCache("feed") para que la siguiente visita no enseñe la lista
 * vieja mientras revalida.
 */
export function invalidateCache(prefix) {
  if(prefix === undefined) { store.clear(); return; }
  for(const key of store.keys()) {
    if(key.startsWith(prefix)) store.delete(key);
  }
}
